/**
 * Created by laugh on 9/21/2017.
 */


export default function (state = "", action) {

    switch (action.type) {
        case 'SET_OFFERS':
            return action.offerResponse
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/offer-response.js